const IconClear = (): JSX.Element => {
  return (
    <>
      <path
        d="M12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12C1 5.92487 5.92487 1 12 1ZM12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3ZM14.1211 8.46484C14.5116 8.07432 15.1446 8.07432 15.5352 8.46484C15.9257 8.85537 15.9257 9.48838 15.5352 9.87891L13.4141 12L15.5352 14.1211C15.9257 14.5116 15.9257 15.1446 15.5352 15.5352C15.1446 15.9257 14.5116 15.9257 14.1211 15.5352L12 13.4141L9.87891 15.5352C9.48838 15.9257 8.85537 15.9257 8.46484 15.5352C8.07432 15.1446 8.07432 14.5116 8.46484 14.1211L10.5859 12L8.46484 9.87891C8.07432 9.48838 8.07432 8.85537 8.46484 8.46484C8.85537 8.07432 9.48838 8.07432 9.87891 8.46484L12 10.5859L14.1211 8.46484Z"
        fill="currentColor"
      />
    </>
  );
};

export default IconClear;
